
import React from 'react';
import Icon from './index';

const vectors = 'M8.7 14.7a1 1 0 0 1-1.4-1.4l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1-1.4 1.4L12 11.42l-3.3 3.3z';

export default function CheveronUp(props) {
  return (
    <Icon {...props} viewBox="0 0 24 24" vectors={vectors} />
  );
}

